import getStores from './get-stores';
import renderStoresList from './render-stores-list';
import initMap from './map';
import geolocate from './geolocate';
import debounce from '../utils/debounce';
import {
    errorMessages,
} from './utils';
import {
    bindStoresListActions,
    selectStore
} from './bind-actions';

const GOOGLE_API_KEY = 'AIzaSyAOZHXtWYER0Rfflp8fRS3qfWs6pSn38T0';

const injectGMap = () => {
    const searchStoresEl = document.querySelector('[data-stores-search]');
    if (!searchStoresEl) {
        return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}`;
    script.async = true;
    script.onload = () => storesSearch();
    document.body.appendChild(script);
};

const storesSearch = () => {
    const geocoder = new google.maps.Geocoder();
    let storesListData = [];

    if (!geocoder) {
        return;
    }

    const searchStoresEl = document.querySelector('[data-stores-search]');
    const storesListEl = document.querySelector('[data-stores-list]');
    const searchInput = searchStoresEl.querySelector('[data-stores-search-input]');
    const errorEl = searchStoresEl.querySelector('[data-error]');
    const geolocateEl = document.querySelector('[data-geolocate]');
    const setIsLoading = isLoading => searchStoresEl.dataset.isLoading = isLoading;
    const setIsError = isError => searchStoresEl.dataset.isError = isError;

    searchInput.addEventListener('keypress', function(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    searchInput.addEventListener('input', debounce(() => {
        if (searchInput.value.length < 3) {
            setIsError(false);
            return;
        }

        setIsError(false);
        setIsLoading(true);

        geocoder.geocode({
            address: searchInput.value.trim(),
            componentRestrictions: {
                country: 'UK'
            }
        }).then((res) => {
            if (!res.results.length) {
                throw new Error(errorMessages.LOCATION_NOT_FOUND_ERROR);
            }

            const {
                results: [{
                    geometry: {
                        location
                    },
                    formatted_address
                }]
            } = res;

            if (formatted_address === 'United Kingdom') {
                throw new Error(errorMessages.LOCATION_NOT_FOUND_ERROR);
            }

            const center = {
                lat: location.lat(),
                lng: location.lng()
            };

            getStores(center.lat, center.lng).then(({
                stores
            }) => {
                const resultsCount = stores.length;
                storesListData = stores;
                storesListEl.innerHTML = `
                    <h2 class="stores-result__title" data-cs-mask>
                        Nearest ${resultsCount} Currys store${resultsCount > 1 ? 's' : ''}
                        to
                        ${formatted_address.replace(', UK', '')}
                    </h2>
                    <div class="stores-result__wrapper" data-cs-mask>
                        <ul class="stores-result__list">
                            ${renderStoresList(stores)}
                        </ul>
                        <div class="stores-result__map" data-map-container></div>
                    </div>
                `;
                bindStoresListActions(storesListEl);
                initMap(center, stores);
            }).catch(() => {
                setIsError(true);
                errorEl.innerHTML = errorMessages.NO_STORES_FOUND_ERROR;
            });
        }).catch((error) => {
            setIsError(true);
            errorEl.innerHTML = error.name === 'MapsRequestError' ?
                errorMessages.LOCATION_NOT_FOUND_ERROR :
                Object.keys(errorMessages)
                    .find(key => errorMessages[key] === error.message) ?
                    error.message :
                    errorMessages.TECHNICAL_ERROR;
        }).finally(() => {
            setIsLoading(false);
        });
    }, 400));

    geolocate(geolocateEl, searchInput, geocoder, setIsLoading);

    if (searchInput.value !== '') {
        searchInput.dispatchEvent(new Event('input'));
    }

    window.addEventListener('store:selected', ({
        detail: {
            storeCode
        }
    }) => {
        selectStore(storeCode, storesListData);
    });
};

export default injectGMap;
